import Model, { attr, belongsTo } from "@ember-data/model";

export default class ArchiveArgumentModel extends Model {
  @attr size;

  @belongsTo("project", { async: false, inverse: "archiveArguments" }) project;
}
